import '../style.scss';
import './accordion.js';
import './swiper.js';
import './hamburger.js';
import './currentPosition.js';
import './header.js';
import './tab.js';
import './newspage.js';
import './form.js';
import './scroll.js';